import { render, staticRenderFns } from "./uusi-paivittainen-merkinta.vue?vue&type=template&id=123fc65f&scoped=true&"
import script from "./uusi-paivittainen-merkinta.vue?vue&type=script&lang=ts&"
export * from "./uusi-paivittainen-merkinta.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-paivittainen-merkinta.vue?vue&type=style&index=0&id=123fc65f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123fc65f",
  null
  
)

export default component.exports